import styles from "./GiftIcon.module.css";

const GiftItem = ({img, amount, openModal}: {img: string, amount: number, openModal?: () => void}) => {
    return (
        <div onClick={openModal} className={styles.inventoryItem}>
            <div className={styles.inventoryEmoji}><img src={img} alt="Gift"/></div>
            <div className={styles.inventoryBadge}>
                <span className={styles.inventoryStar}></span>
                <span className={styles.inventoryValue}>{amount}</span>
            </div>
        </div>
    )
}

export default GiftItem